<template>
  <div class="viewPhotoItem">
    <el-image
      class="center_img"
      :fit="'contain'"
      :src="imgSrc + thumbnail"
      :preview-src-list="getPreviewImages()"
    >
      <template #error>
        <div class="image_slot" @click.stop="fileClick">
          <img class="file_icon" :src="fileIconSrc" />
        </div>
      </template>
    </el-image>

    <el-dialog v-model="showPdf" title="预览" width="100%" top="0px" fullscreen>
      <iframe
        class="view_box"
        :src="`/newPdf/web/viewer.html?file=${imgSrc}`"
      ></iframe>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "viewPhotoItem",
  props: {
    imgSrc: {
      required: true,
    },
    imgList: {
      type: Array,
      default: () => [],
    },
  },
  components: {},
  data: function () {
    return {
      ossUrl: "?x-oss-process=style/preview", //预览图
      thumbnail: "?x-oss-process=style/thumb",
      showPdf: false,
    };
  },
  computed: {
    fileIconSrc() {
      const that = this;
      const srcArr = that.imgSrc.toLowerCase().split(".");
      const fileType = srcArr[srcArr.length - 1];

      const fileTypes = [
        "pdf",
        "doc",
        "docx",
        "ppt",
        "pptx",
        "xls",
        "xlsx",
        "txt",
        "zip",
      ];
      if (fileTypes.includes(fileType)) {
        return require(`@/assets/img/fileicon/${fileType}.png`);
      }

      //视频
      if (
        fileType === "rm" ||
        fileType === "rmvb" ||
        fileType === "wmv" ||
        fileType === "avi" ||
        fileType === "mpg" ||
        fileType === "mpeg" ||
        fileType === "mp4"
      ) {
        return require("@/assets/img/fileicon/sp.png");
      }
      //音频
      if (
        fileType === "mp3" ||
        fileType === "wma" ||
        fileType === "wav" ||
        fileType === "amr"
      ) {
        return require("@/assets/img/fileicon/yy.png");
      }
      return require("@/assets/img/fileicon/others.png");
    },
  },
  mounted: function () {},
  methods: {
    getPreviewImages() {
      const that = this;
      const { imgSrc } = that;

      let tempImgList = this.imgList
        .filter((item) => isImageFile(item))
        .map((item) => item + that.ossUrl);

      //前面过滤了非图片类型文件，之前传的下标可能不对，手动获取一下
      const imgIndex = tempImgList.findIndex((item) => item.includes(imgSrc));

      if (imgIndex == 0) return tempImgList;
      // 调整图片顺序，把当前图片放在第一位
      let start = tempImgList.splice(imgIndex);
      let remain = tempImgList.splice(0, imgIndex);
      return start.concat(remain); //将当前图片调整成点击缩略图的那张图片

      function isImageFile(filePath) {
        if (typeof filePath !== "string") {
          return false;
        }
        const imageExtensions = [
          "png",
          "jpg",
          "jpeg",
          "bmp",
          "webp",
          "svg",
          "tiff",
          "tif",
          "heic",
          "ico",
        ];
        const fileExtension = filePath.split(".").pop().toLowerCase();
        return imageExtensions.includes(fileExtension);
      }
    },
    fileClick() {
      const that = this;
      const { imgSrc } = that;
      if (imgSrc.toLowerCase().endsWith(".pdf")) {
        that.showPdf = true;
      } else {
        that.$message.warning("不支持预览，请下载查看！");
      }
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
.viewPhotoItem {
  width: 100%;
  height: 100%;
  border: 1px solid #f5f5f5;
}
.center_img {
  width: 100%;
  height: 100%;
  position: relative;
  .image_slot {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #333;
    .file_icon {
      width: 100%;
      height: 100%;
    }
  }
}

:deep(.el-dialog__body) {
  height: calc(100% - 72px);
}

.view_box {
  width: 100%;
  height: 100%;
}
</style>